module.exports = __webpack_public_path__ + "static/media/Medellin.f083a9e2.png";